var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"leave-active-class":"out"}},[_c('OzOverlay',{class:[
      'overflow-hidden',
      // Push content to bottom of the screen
      'flex',
      'flex-col',
      'justify-end',
      'items-center',
      // Can remove this once Oz page reset has been applied to all pages.
      'font-sans',
    ],style:({
      paddingTop: 'var(--safe-area-inset-top)',
    }),attrs:{"is-spectral":_vm.isScrimSpectral,"scrim":_vm.xScrim ? 'modal' : null,"should-fade-in":_vm.shouldFadeIn,"z-index-class":_vm.zIndexClass,"dark-mode":_vm.darkMode},on:{"scrim-click":_vm.scrimClick,"scrim-esc":_vm.scrimEsc}},[_c('div',{ref:"modalContainer",class:[
        {
          'mt-96 min-h-auto w-full': true,
          'h-full': _vm.shouldFullSizeCoverScreen,
          'overflow-auto flex flex-col': true,
          'no-scrollbar': _vm.hideScrollbar,
          'modal-container': true,
          'shadow-elevation-5': !_vm.fullSize && !_vm.draggedToFullSize,
          'rounded-none': (_vm.fullSize || _vm.draggedToFullSize) && _vm.MIN_TOP_MARGIN === _vm.minTopMargin,
          'rounded-3xl rounded-br-none rounded-bl-none':
            (!_vm.fullSize && !_vm.draggedToFullSize) || _vm.MIN_TOP_MARGIN > _vm.minTopMargin,
          'full-size': _vm.fullSize || _vm.draggedToFullSize,
          'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
          'bg-light-ui-100 ': _vm.darkMode === false,
          'bg-dark-ui-100': _vm.darkMode === true,
          'pb-safe-inset-bottom': true,
        },
      ]},[_c('div',{ref:"modalContainerInner",class:[
          {
            'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
            'bg-light-ui-100 ': _vm.darkMode === false,
            'bg-dark-ui-100': _vm.darkMode === true,
            'min-h-full flex flex-grow flex-col overflow-hidden': true,
          },
        ]},[_c('div',{ref:"modalContainerInnerWrapper",class:[_vm.isScrollingWholeModal ? 'block' : 'contents', 'pb-0']},[(_vm.xHeader)?_c('header',{ref:"header"},[(_vm.xDrawerHandle)?_c('div',{staticClass:"flex justify-center mb-2 pt-1",attrs:{"id":"tray-expander-controller"}},[_c('div',{staticClass:"rounded w-7 h-1 bg-highway-disabled dark:bg-white-disabled"})]):_vm._e(),_vm._v(" "),_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{ref:"modalBody",class:{
              'h-auto flex flex-grow flex-col p-0 overflow-hidden': true,
              'overflow-y-auto': _vm.fullSize || _vm.draggedToFullSize,
            },on:{"touchstart":_vm.handleTrayScrollStart,"touchmove":_vm.handleTrayScroll,"touchend":function($event){return _vm.$emit('dragend', _vm.dragDistanceY)}}},[_c('div',{ref:"modalBodyContent"},[_vm._t("body")],2)])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }